export enum AttachmentType {
  ASSESSMENT = 'assessment',
  COACH_COVERAGE = 'coach_coverage',
  CONFERENCE = 'conference',
  DOCUMENT = 'document',
  FD = 'fd',
  IMAGE = 'image',
  LINK = 'link',
  MATERIAL = 'material',
  POST = 'post',
  QUESTIONNAIRE = 'questionnaire',
  TASK = 'task',
  USER = 'user',
  VIDEO = 'video',
  VOICE = 'voice',
}

export const NOT_EDITABLE_ATTACHMENT_TYPES = [
  AttachmentType.VOICE,
  AttachmentType.QUESTIONNAIRE,
  AttachmentType.FD,
  AttachmentType.CONFERENCE,
  AttachmentType.TASK,
  AttachmentType.USER,
  AttachmentType.COACH_COVERAGE,
];
